import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react"

const config = defineConfig({
  theme: {
    breakpoints: {
      sm: "600px",
      md: "900px",
      lg: "1000px",
    },
    tokens: {
      colors: {
        brand: {
          50: { value: "#EBF1F9" },
          100: { value: "#99C5FF" },
          200: { value: "#84BAFF" },
          300: { value: "#95B0DD" },
          400: { value: "#6791CB" }, // Primary blue
          500: { value: "#5A7FB5" },
          600: { value: "#4D6D9F" },
          700: { value: "#4A5578" }, // Dark
          800: { value: "#3A4560" },
          900: { value: "#2A3248" },
        },
        success: {
          50: { value: "#ECFDF5" },
          100: { value: "#D1FAE5" },
          200: { value: "#A7F3D0" },
          300: { value: "#6EE7B7" },
          400: { value: "#34D399" },
          500: { value: "#10B981" }, // Green
          600: { value: "#059669" },
          700: { value: "#047857" },
          800: { value: "#065F46" },
          900: { value: "#064E3B" },
        },
        accent: {
          50: { value: "#FEF3E2" },
          100: { value: "#FDE7C5" },
          200: { value: "#FBCF8B" },
          300: { value: "#F9B751" },
          400: { value: "#E8943A" }, // Amber (per D-06 this is the accent)
          500: { value: "#D97706" },
          600: { value: "#B45309" },
          700: { value: "#92400E" },
          800: { value: "#78350F" },
          900: { value: "#451A03" },
        },
      },
      fonts: {
        heading: { value: "'Libre Franklin', sans-serif" },
        body: { value: "'Libre Franklin', sans-serif" },
      },
    },
    semanticTokens: {
      colors: {
        brand: {
          solid: { value: "{colors.brand.400}" },
          contrast: { value: "white" },
          fg: { value: "{colors.brand.700}" },
          muted: { value: "{colors.brand.100}" },
          subtle: { value: "{colors.brand.50}" },
          emphasized: { value: "{colors.brand.500}" },
          focusRing: { value: "{colors.brand.400}" },
        },
        bg: {
          DEFAULT: { value: "#FAFBFE" },
        },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)
